export * from "@b2bportal/core-types/tenant";

export * from "./flights";
export * from "./hotels";
export * from "./wallet";
export * from "./rewards";
export * from "./auth";
export { TenantIconNameEnum } from "./tenantIcons";
export { TenantImageNameEnum } from "./tenantImages";

import type { HotelsCheckoutTrackingAttributes } from "@b2bportal/core-checkout";
import type { AlgomerchTag } from "@hopper-b2b/types";

export type HSBCAlgomerchTag = Exclude<AlgomerchTag, AlgomerchTag.BestQuality>;

export enum TenantFlightSteps {
  ONBOARDING = "ONBOARDING",
  FINTECH_MARKETPLACE = "FINTECH_MARKETPLACE",
  FREEZE = "FREEZE",
}

export enum TenantHotelSteps {
  FINTECH_MARKETPLACE = "FINTECH_MARKETPLACE",
  ONBOARDING = "ONBOARDING",
}

export enum TenantCarSteps {
  ONBOARDING = "ONBOARDING",
}

export type TenantGlobalTrackingAttributes = HotelsCheckoutTrackingAttributes;
